export const getStatusText = (t: (v: string) => string, status?: string) => {
  if (status === 'To do' || status === 'TO_DO') return t('productStatus.TO_DO');
  if (status === 'In progress' || status === 'IN_PROGRESS') return t('productStatus.IN_PROGRESS');
  if (status === 'Pending' || status === 'PENDING') return t('productStatus.PENDING');
  if (status === 'Done' || status === 'DONE') return t('productStatus.DONE');
  return '';
};
